import {Injectable} from '@angular/core';

@Injectable()
export class StorageService {
    get(key: string): any {
        return window.localStorage[key];
    }

    set(key: string, value: any): void {
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        window.localStorage[key] = value;
    }

    delete(key: string): void {
        window.localStorage.removeItem(key);
    }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/services/storage.service.ts